const TeamSection = () => {
  const teamMembers = [
    {
      name: "Thành Ninh",
      role: "",
      image:
        "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759246674/550191108_24632725416367967_6281735199596344080_n_1_gdssll.png",
    },
    {
      name: "Minh Ly",
      role: "",
      image:
        "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759246676/549284148_24609288012045041_833296004394531786_n_1_xbhdrm.png",
    },
  ];

  return (
    <section className="w-full bg-gray-100 py-16 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto text-center space-y-8">
        <h2 className="text-2xl lg:text-4xl font-bold text-gray-800">
          Đội Ngũ Của Chúng Tôi
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="text-center">
              <img
                src={member.image}
                alt={member.name}
                className="w-40 h-40 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-lg font-bold text-gray-700">{member.name}</h3>
              <p className="text-gray-500">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
